<template>
  <a-modal
    :title="title"
    :visible="visible.saveModal"
    @ok="ok"
    @cancel="cancel" 
    destroyOnClose 
    :maskClosable="false"
    width="600px"
  >
    <div slot='footer'>
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="ok" :loading="saveLoding">确定</a-button>
    </div>
    <a-form :form="form" class="headForm" :label-col="{xs: { span: 24 },sm: { span: 3 }}">
      <a-form-item label="原料">
        <a-checkbox-group v-model="materialArr">
          <a-checkbox value="RAW_PRICE">
            原料价格
          </a-checkbox>
          <a-checkbox value="RAW_NUTRITION">
            原料营养指标
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="配方优化">
        <a-checkbox-group v-model="formulaArr">
          <a-checkbox value="SIMULATION">
            <!-- 原料最大值、最小值数据；营养指标最大值、最小值等数据； -->
            原料用量、最大值、最小值等数据；营养指标数值、最大值、最小值等数据
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { nhfMixins } from '../../untils'
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  mixins: [nhfMixins],
  data(){
    return {
      title: <p>保存<span style={{color: '#ccc','font-size': '10px','margin-left': '10px'}}>选择需要正式保存和更新的数据</span></p>,
      form: this.$form.createForm(this),
      materialArr: [],
      formulaArr: [],
      saveLoding: false
    }
  },
  watch:{
    'visible.saveModal': {
      handler(val){
        if(val){
          this.materialArr = []
          this.formulaArr = []
        }
      },
      deep: true
    }
  },
  methods:{
    async ok(){
      if(this.formulaArr.length === 0 && this.materialArr.length === 0) {
        this.$message.warning('请选择保存数据')
        return
      }
      let dataTypeListStr = this.formulaArr.concat(this.materialArr)
      let formulaId = getRequest("id")
      this.saveLoding = true
      await this.fetchPost({
        actions: this.saveTempDataToMain,
        showMessage: true,
        data:{
          dataTypeListStr,formulaId
        }
      })
      // let {success,msg} = res || {}
      // console.log(res)
      // if(success) {
      //   this.$message.success(msg)
      // }else{
      //   this.$message.warning(msg)
      // }
      this.saveLoding = false
      this.toggleVisible("saveModal");
    },
    cancel(){
      this.toggleVisible("saveModal");
    },
  }
}
</script>